import { render, staticRenderFns } from "./EditOurCourses.vue?vue&type=template&id=e2669c36&scoped=true&"
import script from "./EditOurCourses.vue?vue&type=script&lang=js&"
export * from "./EditOurCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2669c36",
  null
  
)

export default component.exports